export const Base_URL = 'https://webstatic.omnicasa.com/';
export const API_URL_SEND_MAIL = 'https://63c013eb.ngrok.io/api/';
export const CustomerName = 'QAF4';
// export const CustomerID = '664'; // id customer immovanparijs
export const CustomerID = '1477'; // id customer QAF4
